import './Cta.scss';

import Button from '../../../../components/ui/Button';

const Cta = ({ image }) => {
    return (
        <section className="Cta">
            <div className="container">
                <div className="block-wrapper">
                    <div className="block text--center block--column">
                        <img className="img-responsive" src={image} alt="" />
                        <h1 className="heading heading--large heading--white">
                            kijk naar alle wedstrijden
                            <br />
                            van de Eredivisie en meer!
                        </h1>
                        <span className="text text--white">
                            Zorg dat je niks meer mist.
                        </span>
                        <Button
                            label="Nog geen ESPN abonnement?"
                            link="/abonneren"
                            type="primary"
                            size="large"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Cta;
